// Универсальная карточка метрики: лейбл + большое значение + опц. подзаголовок и тренд.
// Используется на Health/Behavior табах: DTI, Runway, Savings, Liquidity, Streak, и т.п.

import type { ReactNode } from 'react';

type Tone = 'good' | 'warn' | 'bad' | 'neutral';

type Props = {
  label: string;
  value: string;
  hint?: string;
  tone?: Tone;
  trendPct?: number | null; // если задано — показываем рядом с value (+12% / −8%)
  icon?: ReactNode;
};

export function MetricCard({ label, value, hint, tone = 'neutral', trendPct, icon }: Props): JSX.Element {
  const trendNode =
    trendPct == null
      ? null
      : (
          <span className={`metric-trend ${trendPct >= 0 ? 'up' : 'down'}`}>
            {trendPct >= 0 ? '+' : ''}
            {trendPct.toFixed(0)}%
          </span>
        );
  return (
    <div className={`metric-card metric-${tone}`}>
      <div className="metric-label">
        {icon ? <span className="metric-icon">{icon}</span> : null}
        {label}
      </div>
      <div className="metric-value">
        {value}
        {trendNode}
      </div>
      {hint ? <div className="metric-hint">{hint}</div> : null}
    </div>
  );
}
